import React from 'react'
import { Info } from '../../components/KeyRecovery/Info'

export const RecoveryInfo = () => <Info />
